export default __webpack_public_path__ + "assets/_Chapters/EPLSystem/lid_br_er.webp";